export default "__VITE_ASSET__DTin76Ac__"